import React from 'react';
import PropTypes from 'prop-types';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { dataAttrs } from 'Helpers/Testing';

const PrimaryActionLinkButton = ({
  relationship,
  onClick,
  test,
}) => {
  return (
    <RoundedButton
      component={'a'}
      variant="contained"
      color={'primary'}
      onClick={onClick}
      disableElevation
      padding={'dense'}
      fullWidth
      href={relationship.link('related').url()}
      target="_blank"
      {...dataAttrs(test)}
    >
      {relationship.meta('prompt') || 'Schedule Meeting'}
    </RoundedButton>
  );
};

PrimaryActionLinkButton.defaultProps = {
  onClick: undefined,
  test: 'primary-action-link-button',
};

PrimaryActionLinkButton.propTypes = {
  relationship: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  test: PropTypes.string,
};

export default PrimaryActionLinkButton;
